import React from 'react';
import { Lang } from 'shared/constants/lang';
import { FAVORITES_ENTITIES, EVENTS } from 'shared/constants';
import styles from './favorites-button.module.scss';
import classNames from 'classnames';
import analyticsService from '../../helpers/analytics.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark as faBookmarkFilled } from '@fortawesome/free-solid-svg-icons/faBookmark';
import { faBookmark } from '@fortawesome/free-regular-svg-icons/faBookmark';
import { IconButton } from '../design-system/buttons';

const FavoritesButtonComponent = ({
  id = '',
  wrapper = styles.buttonWrapper,
  className = styles.favoritesIcon,
  toggleFavorites = () => {},
  isFavorite = false,
  lang = Lang.ACTION_BUTTON_TOOLTIPS,
  background = null,
  entity = FAVORITES_ENTITIES.KNOWLEDGE,
}) => {
  const toggleFavoritesItem = e => {
    e.stopPropagation();
    e.preventDefault();

    analyticsService.track(
      `${isFavorite ? EVENTS.FAVORITES.REMOVE : EVENTS.FAVORITES.ADD} - ${
        entity === FAVORITES_ENTITIES.KNOWLEDGE
          ? FAVORITES_ENTITIES.KNOWLEDGE
          : FAVORITES_ENTITIES.CONTACT
      }`,
      {
        id,
      },
    );

    toggleFavorites({ id, entity });
  };

  const favoriteLabel = isFavorite ? lang.FAVORITES_REMOVE : lang.FAVORITES;

  return (
    <IconButton
      onClick={toggleFavoritesItem}
      className={classNames([wrapper, background])}
      label={favoriteLabel}
      aria-pressed={isFavorite}>
      <FontAwesomeIcon className={className} icon={isFavorite ? faBookmarkFilled : faBookmark} />
    </IconButton>
  );
};

export { FavoritesButtonComponent };
